export const metaTag = {
    transavia: {
      'nl-NL': "Bij Transavia Holidays regel je alles in één keer: je vlucht, hotel en auto. De beste deals voor ieder budget. Stel zelf jouw complete vakantie samen.",
      'en-GB': "With Transavia Holidays you can book your entire dream holiday. Choose your destination, book a hotel, and even rent a car. All that in one go, and at a competitive price."
    },
    klm: {
      'nl-NL': "Boek je complete reis bij KLM Holidays | Voordelige pakketreizen. Stel je perfecte vakantie samen. Boek je vlucht, verblijf en eventueel vervoer. Kies uit honderden bestemmingen.",
      'en-GB': "Book your complete holiday with KLM Holidays | Advantageous package trips Put together your ideal holiday. Book your flight, accommodation and any transport. Choose from hundreds of destinations."
    }
  };